import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import { useAuth } from '../contexts/AuthContext';

const RemovedFromCompany = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/', { replace: true });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to sign out after removal:', e);
    }
  };

  const handleNewCode = () => {
    navigate('/', { replace: true });
  };

  const removalDate = userData?.removedFromCompanyAt && userData.removedFromCompanyAt.toDate
    ? userData.removedFromCompanyAt.toDate()
    : null;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'var(--branding-app-surface)',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    }}>
      <div style={{
        maxWidth: 480,
        width: '100%',
        background: '#ffffff',
        borderRadius: 16,
        padding: 24,
        boxShadow: '0 10px 30px rgba(15,23,42,0.12)',
        border: '1px solid #e2e8f0',
      }}>
        <h1 style={{ fontSize: 22, margin: 0, marginBottom: 8, color: '#111827' }}>
          You no longer have access to this company
        </h1>
        {userData?.previousCompanyName && (
          <p style={{ margin: 0, marginBottom: 8, color: '#4b5563', fontSize: 14 }}>
            Company: <strong>{userData.previousCompanyName}</strong>
          </p>
        )}
        {removalDate && (
          <p style={{ margin: 0, marginBottom: 8, color: 'var(--cc-text-muted)', fontSize: 13 }}>
            Removed on {removalDate.toLocaleDateString()}.
          </p>
        )}
        <p style={{ marginTop: 8, marginBottom: 16, color: '#4b5563', fontSize: 14, lineHeight: 1.6 }}>
          If you think this is a mistake, please contact your company administrator or{' '}
          <a href="mailto:support@crewchain.co.uk" style={{ color: 'var(--branding-app-primary)' }}>support@crewchain.co.uk</a>.
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={handleNewCode}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: 'none',
              background: '#1d4ed8',
              color: '#ffffff',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Sign up with a new company code
          </button>
          <button
            type="button"
            onClick={handleSignOut}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: '1px solid #d1d5db',
              background: '#ffffff',
              color: 'var(--cc-text-secondary)',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemovedFromCompany;

